import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10.4581 7.5H19.5419L23.4375 14.824L19.5275 21.5625H10.4725L6.5625 14.824L10.4581 7.5ZM11.1687 8.63147L7.88731 14.8007L11.1543 20.431H18.8457L22.1127 14.8007L18.8313 8.63147H11.1687Z'
  }),
  React.createElement('path', { d: 'M22.7297 14.3906H28.395V15.6094H22.7297V14.3906Z' }),
  React.createElement('path', { d: 'M1.60504 14.3906H7.53005V15.6094H1.60504V14.3906Z' })
));